import openWindow from '../../util/open_window'
import openApplicationTroubleshoot from '../../util/open_application_troubleshoot'

export default async function termsAgreement (state, appOptions, lastPage) {
  const TermsAgreement = (await import(/* webpackChunkName: 'component-terms-agreement' */ '../../components/terms_agreement')).default

  const view = new TermsAgreement({
    user: state.get('user'),
    showNavigation: state.get('role') === 'participant',
    tabProfile: state.get('role'),
    activeTab: state.get('page')
  })

  view.on('click:url', async (url) => openWindow(url, state))
  view.on('click:contact', () => openApplicationTroubleshoot(state))

  view.on('done', () => {
    // update the flag so we don't show the page again
    state.get('participant').set({ must_consent: false })
    if (lastPage === 'terms_agreement') {
      lastPage = 'home'
    }

    state.changePage(lastPage)
  })

  return view
}
